import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
const AttributeStrategySelectorInner = lazy(() => import("./AttributeStrategySelectorInner"));
export function AttributeStrategySelector() {
    return (_jsx(Suspense, { children: _jsx(AttributeStrategySelectorInner, {}) }));
}
//# sourceMappingURL=AttributeStrategySelector.js.map